import qs from 'query-string'

export default class FetchFilter {
  constructor (node, onSubmit) {
    this.node = node
    this.onSubmit = onSubmit
    this.init()
  }

  init () {
    this.criterias = {}
    this.tags = this.node.querySelector('[data-list]')

    this.setCriteriasFromUrl()
    this.showCriterias()

    const filterButton = this.node.querySelector('[data-filter]')

    if (filterButton) {
      filterButton.addEventListener('click', e => this.submit())
    }

    this.node.querySelector('[data-clear]').addEventListener('click', e => {
      this.reset()
      this.submit()
    })
  }

  setCriteriasFromUrl () {
    const userParams = qs.parse(location.search)

    Object.keys(userParams).forEach(taxonomy => {
      const checkboxes = this.node.querySelectorAll(`[data-criteria=${taxonomy}] input[type=checkbox]`)
      const selectedTitles = userParams[taxonomy]
      const selectedValues = []

      checkboxes.forEach(checkbox => {
        if (selectedTitles.includes(checkbox.dataset.title)) {
          checkbox.checked = true
          selectedValues.push({
            title: checkbox.dataset.title,
            slug: checkbox.value,
          })
        }
      })

      if (selectedValues.length > 0) {
        this.criterias[taxonomy] = selectedValues
      }
    })
  }

  setCriterias () {
    this.criterias = {}

    this.node.querySelectorAll('[data-criteria]').forEach(criteria => {
      const values = []

      criteria.querySelectorAll('input[type=checkbox]:checked').forEach(checkbox => {
        values.push({
          title: checkbox.dataset.title,
          slug: checkbox.value,
        })
      })

      if (values.length > 0) {
        this.criterias[criteria.dataset.criteria] = values
      } else {
        delete this.criterias[criteria.dataset.criteria]
      }
    })
  }

  clearTags () {
    while (this.tags.firstElementChild && !this.tags.firstElementChild.hasAttribute('data-clear')) {
      this.tags.removeChild(this.tags.firstElementChild)
    }
  }

  reset () {
    this.clearTags()
    this.checkForCleanButton()
    this.criterias = {}
    this.node.querySelectorAll('input[type=checkbox]').forEach(checkbox => {
      checkbox.checked = false
    })
  }

  showCriterias () {
    this.clearTags()

    Object.keys(this.criterias).forEach(taxonomy => {
      this.criterias[taxonomy].forEach(criteria => {
        const item = document.createElement('li')
        this.addTagRemoveListener(item)
        item.innerHTML = criteria.title
        item.dataset.taxonomy = taxonomy
        item.dataset.slug = criteria.slug
        this.tags.prepend(item)
      })
    })

    this.checkForCleanButton()
  }

  generateTaxonomyQuery () {
    return Object.keys(this.criterias)
      .map(taxonomy => this.criterias[taxonomy].map(value => `${taxonomy}/${value.slug}`))
      .reduce((accumulator, current) => accumulator.concat(current), [])
      .join('|')
  }

  updatePageUrl () {
    const criterias = {}

    Object.keys(this.criterias).forEach(taxonomy => {
      criterias[taxonomy] = this.criterias[taxonomy].map(value => value.title)
    })

    const hasCriterias = Object.keys(criterias).length > 0
    const pageUrl = hasCriterias ? ('?' + qs.stringify(criterias)) : window.location.href.split('?').shift()
    window.history.pushState('', '', pageUrl)
  }

  addTagRemoveListener (tag) {
    tag.addEventListener('click', e => {
      const values = this.criterias[tag.dataset.taxonomy]
      const value = values.find(value => value.slug === tag.dataset.slug)
      const index = values.indexOf(value)

      if (values.length === 1) {
        delete this.criterias[tag.dataset.taxonomy]
      } else {
        values.splice(index, 1)
      }

      this.node.querySelector(`input[type=checkbox][value="${value.slug}"]`).checked = false
      tag.remove()
      this.checkForCleanButton()
      this.updatePageUrl()
      this.onSubmit()
    })
  }

  checkForCleanButton () {
    this.tags.classList.toggle('clear', this.tags.children.length > 4)
  }

  submit () {
    this.setCriterias()
    this.updatePageUrl()
    this.showCriterias()
    this.onSubmit()
  }
}



// WEBPACK FOOTER //
// ./themes/default/js/models/FetchFilter.js